// DecisionFormContext.tsx
import React, { createContext, useContext, useReducer, ReactNode, useEffect } from 'react';
import { reducer, initialState } from './formReducer';
import { DecisionFormContextType } from './DMContextInterfaces';

const DecisionFormContext = createContext<DecisionFormContextType | undefined>(undefined);

export function DecisionFormProvider({ children }: { children: ReactNode }) {
  const [ state, dispatch ] = useReducer(reducer, initialState);

  useEffect(() => {
    if (state.formUpdated) {
      // dispatch({ type: 'RESET_FORM_UPDATED' });
    }
  }, [ state.formUpdated ]);

  return (
    <DecisionFormContext.Provider value={{ state, dispatch }}>
      {children}
    </DecisionFormContext.Provider>
  );
}

export function useDecisionFormContext() {
  const ctx = useContext(DecisionFormContext);
  if (!ctx) throw new Error('useDecisionFormContext must be used within DecisionFormProvider');
  return ctx;
}
